import cn from '../../../common/className.js'
import Icon from '../../../common/icons/Icon.js'

const ALLOCATION_ICONS = {
  allocated: 'circle-full',
  partially_allocated: 'circle-half',
  unallocated: 'circle-o',
  overallocated: 'stop-1',
  allocation_attempted: 'subtract',
}

export default function LineAllocationIcon({
  allocationStatus,
  allocationHint,
  isDropship,
  isDropshipHint,
  className,
}) {
  if (!allocationStatus) {
    return null
  }

  return (
    <div
      className={cn`wrap--order-allocation ${className} ${{
        allocated: allocationStatus === 'allocated',
        'partially-allocated': allocationStatus === 'partially_allocated',
        unallocated: allocationStatus === 'unallocated',
        overallocated: allocationStatus === 'overallocated',
      }}`}
    >
      <div className="tooltip--top" data-hint={allocationHint}>
        <Icon
          name={ALLOCATION_ICONS[allocationStatus] || 'circle-o'}
          className="fs-00"
        />
      </div>
      {isDropship && (
        <div className="margin-right-3">
          <div className="tooltip--top" data-hint={isDropshipHint}>
            <Icon name="truck" />
          </div>
        </div>
      )}
    </div>
  )
}
